/** SMS-hez: GSM-7 karakterkészlet, így 160 karakter fér egy szeletbe. */
export function ekezetMentes(s: string): string {
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '');
}

const HTML: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
export function htmlEscape(s: string): string {
  return s.replace(/[&<>"']/g, (c) => HTML[c] ?? c);
}

/** Névelő a név elé: magánhangzós kezdetnél „az”, egyébként „a”. */
export function nevelos(nev: string): string {
  return /^[aáeéiíoóöőuúüű]/i.test(nev.trim()) ? `az ${nev}` : `a ${nev}`;
}
